import { isNil } from 'lodash'

const areValuesDefined = (...values) => {
  return values.every((value) => !isNil(value))
}

export default areValuesDefined
